<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <div class="MenuBtnWrap">
          <div class="btn" @click="getdemanger">
            添加默認管理員
          </div>
          <div class="btn" @click="$router.push('/addcheckActivity')">
            新增核銷活動
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="activityList"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暫無數據"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in activityTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'type'">
                <div v-if="scope.row.type == 0">一般活動</div>
                <div v-else-if="scope.row.type == 1">演唱會</div>
                <div v-else-if="scope.row.type == 2">見面會</div>
                <div v-else-if="scope.row.type == 3">後台活動</div>
              </div>
              <div v-else-if="item.prop === 'status'">
                <div v-if="scope.row.status == 0">
                  未開始
                </div>
                <div v-else-if="scope.row.status == 1">
                  已開始
                </div>
                <div v-else-if="scope.row.status == 2">
                  已結束
                </div>
              </div>
              <div
                v-else-if="item.prop === 'startTime' || item.prop === 'endTime'"
              >
                {{ $dayjs(scope.row[item.prop]).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="核銷詳情" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="goManager(scope.row, 'detail')" type="text"
                >查看詳情</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="中獎詳情" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="getlottery(scope.row.id,scope.row.special)"
                type="text"
                :disabled="scope.row.winning == 0"
                >中獎名單</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex;">
                <el-button
                  @click="
                    $router.push(
                      `/addcheckActivity?item=${encodeURIComponent(JSON.stringify(scope.row))}`
                    )
                  "
                  type="text"
                  :disabled="scope.row.status != 0"
                  >編輯</el-button
                >
                <el-button
                  type="text"
                  :disabled="scope.row.status != 0"
                  @click="uploadFunction(scope.row.id)"
                  >上傳名單</el-button
                >
                <el-button
                  type="text"
                  :disabled="scope.row.status == 2"
                  @click="goManager(scope.row, 'manager')"
                  >管理員</el-button
                >
                <el-button
                  @click="delActivity(scope.row.id)"
                  type="text"
                  :disabled="scope.row.status == 1"
                  >刪除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 上传弹窗 -->
    <el-dialog
      title="上傳名单"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div style="display:flex;justify-content: flex-end;">
        <div
          v-throttle="{ fn: download, time: 3000 }"
          style="color:#6c3dea;text-align:right;font-size:14px;cursor:pointer"
        >
          下載模版
        </div>
      </div>
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.qrcodePostUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
            :data="{
              id: this.nowId
            }"
            name="multipartFile"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px'
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="margin-right:112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">确认更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 中奖详情 -->
    <el-dialog
      title="中獎詳情"
      :visible.sync="isLottery"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="50%"
      center
      @close="closeLottery"
    >
      <div>
        <div style="display: flex;align-items: center;">
          <div>賬號：</div>
          <el-input
            style="width: 200px;margin-left: 20px;"
            v-model="account"
            placeholder="請輸入會員賬號"
          ></el-input>
          <div class="searchbtn" @click="search">
            查詢
          </div>
          <div
            class="searchbtn"
            style="background-color: #999999;"
            @click="reast"
          >
            重置
          </div>
        </div>
        <div>
          <el-table
            stripe
            :data="isLotterylist"
            height="350px"
            style="width:100%;"
          >
            <el-table-column
              v-for="(item, index) in isLotteryTable"
              :key="index"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <div v-if="item.prop === 'winningTime'">
                  {{
                    $dayjs(scope.row[item.prop]).format("YYYY-MM-DD HH:mm:ss")
                  }}
                </div>
                <div v-else>
                  {{ scope.row[item.prop]}}
                </div>
              </template></el-table-column
            >
            <el-table-column label="幸運號碼" prop="winningNumber" v-if="special==1">
              
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-block clearfix">
          <el-pagination
            class="paging fr"
            @current-change="handlelotters"
            :current-page="lotterypage"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next, jumper"
            :total="lotterytotal"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 新增默认管理员 -->
    <el-dialog
      title="新增默認管理員"
      :visible.sync="demangers"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="50%"
center
    >
      <div>
        <div style="display: flex;align-items: center;">
          <div>賬號：</div>
          <el-input
            style="width: 200px;margin-left: 20px;"
            v-model="username"
            placeholder="請輸入賬號"
          ></el-input>
          <div class="searchbtn" v-throttle="{ fn: addmanger, time: 2000 }">
            添加
          </div>
        </div>
        <div>
          <el-table
            stripe
            :data="mangerlist"
            height="350px"
            style="width:100%;"
          >
            <el-table-column prop="username" label="郵箱" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="demanger(scope.row.id)"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging-block clearfix">
          <el-pagination
            class="paging fr"
            @current-change="handleCurrentChangemanger"
            :current-page="page"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { Indicator } from "mint-ui";

export default {
  data() {
    return {
      isLottery: false,
      navBlock: "活動",
      navtitle: "核銷活動",
      activityList: [],
      isLotterylist: [],
      mangerlist: [],
      account: "",
      demangers: false,
      username: "",
      special:'',
      isLotteryTable: [
        {
          label: "中獎時間",
          prop: "winningTime"
        },
        {
          label: "會員賬號",
          prop: "username"
        },
        {
          label: "真實姓名",
          prop: "name"
        },
        {
          label: "證件號",
          prop: "idCard"
        },
    
      ],
      activityTable: [
        {
          prop: "id",
          label: "核銷活動ID",
          width: "170"
        },
        {
          prop: "activityName",
          label: "活動名稱",
          width: "160"
        },
        {
          prop: "type",
          label: "活動類型",
          width: "100"
        },
        {
          prop: "status",
          label: "活動核銷狀態",
          width: "170"
        },
        {
          prop: "startTime",
          label: "核銷開始時間",
          width: "160"
        },
        {
          prop: "endTime",
          label: "核銷結束時間",
          width: "160"
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      pageSize: 10,
      uoloadModal: false,
      fileList: [],
      nowId: "",
      page: 1,
      totals: 0,
      lotterypage: 1,
      lotterytotal: 0,
      lotteryid: ""
    };
  },
  created() {
    this.getActivityList();
  },
  activated() {
    if (this.currentPage === 1) {
      this.getActivityList();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    closeLottery() {
      this.account = "";
    },
    search() {
      this.lotterypage = 1;
      
      this.getlottery(this.lotteryid,this.special);
    },
    reast() {
      this.account = "";
      this.lotterypage = 1;
      this.getlottery(this.lotteryid,this.special);
    },
    getlottery(id,special) {
      this.lotteryid = id;
      this.special=special
  
      
      this.$get(
        `/write/off/activity/winning/record?page=${this.lotterypage}&size=10&id=${id}&username=${this.account}`,
        this.$GLOBAL.jsonConfig
      )
        .then(res => {
          if (res.code == "00000") {
            if (!this.isLottery) {
              this.isLottery = true;
            }
            this.isLotterylist = res.data.list;
            this.lotterytotal = res.data.total;
          } else {
            this.$warnMessage(res.message);
          }
        })
        .catch(err => {
          this.$warnMessage(err.message);
        });
    },
    addmanger() {
      if (!this.username) {
        this.$warnMessage("請輸入賬號");
        return;
      }
      //新增前查詢
      this.$get(
        `/write/off/activity/manager?username=${this.username}`,
        this.$GLOBAL.jsonConfig
      )
        .then(res => {
          if (res.code == "00000") {
            let params = {
              activityId: 0,
              username: this.username
            };
            this.$post(
              `/write/off/activity/default/manager`,
              params,
              this.$GLOBAL.jsonConfig
            )
              .then(res => {
                if (res.code == "00000") {
                  this.$message({
                    message: "添加成功",
                    type: "success",
                    center: true,
                    duration: 1000
                  });

                  this.username = "";
                  this.page = 1;
                  this.getdemanger();
                } else {
                  this.$warnMessage(res.message);
                }
              })
              .catch(err => {
                this.$warnMessage(err);
              });
          } else {
            this.$warnMessage(res.message);
          }
        })
        .catch(err => {
          this.$warnMessage(err);
        });
    },
    //刪除默認管理員
    demanger(id) {
      this.$del(`/write/off/activity/manager/${id}`, this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code == "00000") {
            this.$message({
              message: "刪除成功",
              type: "success",
              center: true,
              duration: 1000
            });
            this.page = 1;
            this.getdemanger();
          } else {
            this.$warnMessage(res.message);
          }
        })
        .catch(err => {
          this.$warnMessage(err);
        });
    },
    //獲取默認管理員
    getdemanger() {
      let _this = this;
      this.username = "";
      _this
        .$get(
          `/write/off/activity/manager/list?page=${_this.page}&size=10&activityId=0`,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.demangers = true;
            _this.mangerlist = res.data.list;
            _this.totals = res.data.total;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 获取活动列表信息
    getActivityList() {
      this.$get(
        `/write/off/activity/list?page=${this.currentPage}&size=${this.pageSize}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          console.log(res);

          this.activityList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    goManager(param, type) {
    console.log(param);
    
      if (type === "detail") {
        this.$router.push(
          `/checkList?activityId=${param.id}&activityName=${encodeURIComponent(param.activityName)}&mode=${param.mode}`
        );
      } else {
        this.$router.push(`/mangerList?params=${encodeURIComponent(JSON.stringify(param))}`);
      }
    },

    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getActivityList();
    },
    //默認管理員分頁
    handleCurrentChangemanger(val) {
      this.page = val;
      this.getdemanger();
    },
    handlelotters(val) {
      this.lotterypage = val;
      this.getlottery(this.lotteryid,this.special);
    },
    // 删除活动
    delActivity(id) {
      let _this = this;
      _this
        .$confirm("是否刪除該核銷活動?", "提示信息", {
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          // 确认删除的回调
          _this
            .$get(
              `/write/off/activity/delete?id=${id}`,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                this.$message({
                  message: "删除成功",
                  type: "success",
                  center: true
                });
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.getActivityList();
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            })
            .catch(() => {});
        })
        .catch(err => {});
    },
    // 上传名单
    uploadFunction(id) {
      this.uoloadModal = true;
      this.nowId = id;
    },
    fileChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    successExcel(res, file, fileList) {
      let _this = this;
      Indicator.close();
      this.$nextTick(() => {
        if (res.code === "00000") {
          _this.$refs.excelUpload.clearFiles();
          _this.uoloadModal = false;
          _this.$propMessage("名單上傳成功", "success", () => {
            this.getActivityList();
          });
        } else {
          _this.$refs.excelUpload.clearFiles();
          _this.uoloadModal = false;
          _this.$propMessage(res.message, "error", () => {});
        }
      });
    },
    errorExcel(err, file, fileList) {
      Indicator.close();
      this.$nextTick(() => {
        let _this = this;
        _this.$refs.excelUpload.clearFiles();
        _this.dialogVisible = true;
        _this.$propMessage(err.message + ",請重新上傳", "error", function() {
          _this.dialogVisible = false;
        });
      });
    },
    submitupdate() {
      let _this = this;
      if (_this.fileList.length == 0) {
        _this.dialogVisible = true;
        _this.$propMessage("请上傳名單", "error", function() {
          _this.dialogVisible = false;
        });
        return;
      }
      Indicator.open("數據處理中，請耐心等待");
      this.$refs.excelUpload.submit();
    },
    download() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/Write-off_Activity_Record.xlsx"
      );
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.dialog {
  display: flex;
  justify-content: center;
  max-height: 80vh;
  overflow-y: auto;
  .el-upload__tip {
    color: #65676b;
  }
  .dialogrow {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    /deep/ .el-checkbox {
      width: 150px !important;
      text-align: left;
      display: block !important;
      margin-right: 0px !important;
    }
    /deep/ .el-input {
      width: 190px !important;
    }
    .badgeadd {
      width: 80px;
      color: rgba(147, 144, 163, 1);
      background: rgba(242, 240, 247, 1);
      text-align: center;
      cursor: pointer;
      line-height: 36px;
      margin-left: 9px;
      border-radius: 6px;
    }
    .badgedelete {
      width: 80px;
      text-align: center;
      color: #6c3dea;
      line-height: 36px;
      margin-left: 9px;
      cursor: pointer;
    }
  }
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    text-align: center;
  }
}
/deep/ .el-dialog {
  border-radius: 12px;
}
/deep/ .el-dialog__header {
  //   box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}
/deep/ .el-dialog__title {
  font-size: 0.16rem;
}
/deep/ .el-upload__text em {
  color: #6c3dea !important;
}
/deep/ .el-upload-dragger:hover {
  border-color: #6c3dea !important;
}
/deep/ .el-upload-dragger {
  width: 320px !important;
  border: 1px dashed #d9d9d9 !important;
}
/deep/.el-table__empty-block {
  min-height: 350px !important;
}
.searchbtn {
  width: 80px;
  height: 30px;
  background-color: #6c3dea;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  margin-left: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkActivity/activityList.vue